export const ASSIGNMENTS_LOAD_REQUEST = 'ASSIGNMENTS_LOAD_REQUEST';
export const ASSIGNMENTS_LOAD_SUCCESS = 'ASSIGNMENTS_LOAD_SUCCESS';
export const ASSIGNMENTS_LOAD_FAILURE = 'ASSIGNMENTS_LOAD_FAILURE';
export const START_ASSIGNMENTS_POLLING = 'START_ASSIGNMENTS_POLLING';
